module.exports = __webpack_public_path__ + "ce124e28ec5e72d84ee2d276e8399dcd.jpg";